import { useState } from "react";
import { Box, Grid, Typography, styled, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { setVisibilityFilter } from "../../redux/action";

const BoxStyled = styled(Box)(() => ({
  padding: "30px",
  transition: "0.1s ease-in",
  cursor: "pointer",
  color: "inherit",
  "&:hover": {
    transform: "scale(1.03)",
  },
}));

function TicketFilter({ ticketsFetch }) {
  const dispatch = useDispatch();
  const [activeFilter, setActiveFilter] = useState("total_tickets");
  const pendingC = ticketsFetch.filter(t => t.Status === "Pending").length;
  const openC = ticketsFetch.filter(t => t.Status === "Open").length;
  const closeC = ticketsFetch.filter(t => t.Status === "Closed").length;
  const theme = useTheme();
  return (
    <Grid container spacing={3} textAlign="center">
      <Grid item xs={12} md={6} lg={3}>
        <BoxStyled
          onClick={() => {
            setActiveFilter("total_tickets");
            dispatch(setVisibilityFilter("total_tickets"));
          }}
          sx={{
            backgroundColor: activeFilter === "total_tickets" ? theme.palette.primary.main : theme.palette.primary.light,
            color: activeFilter === "total_tickets" ? " #fff" : theme.palette.primary.main,
            borderRadius: activeFilter === "total_tickets" ? "10px" : "0",
            transition: "0.3s all",
          }}
        >
          <Typography variant="h3">{ticketsFetch.length}</Typography>
          <Typography variant="h6">Total Tickets</Typography>
        </BoxStyled>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <BoxStyled
          onClick={() => {
            setActiveFilter("Pending");
            dispatch(setVisibilityFilter("Pending"));
          }}
          sx={{
            backgroundColor: activeFilter === "Pending" ? theme.palette.warning.main : theme.palette.warning.light,
            color: activeFilter === "Pending" ? " #fff" : theme.palette.warning.main,
            borderRadius: activeFilter === "Pending" ? "10px" : "0",
            transition: "0.3s all",
          }}
        >
          <Typography variant="h3">{pendingC}</Typography>
          <Typography variant="h6">Pending Tickets</Typography>
        </BoxStyled>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <BoxStyled
          onClick={() => {
            setActiveFilter("Open");
            dispatch(setVisibilityFilter("Open"));
          }}
          sx={{
            backgroundColor: activeFilter === "Open" ? theme.palette.success.main : theme.palette.success.light,
            color: activeFilter === "Open" ? " #fff" : theme.palette.success.main,
            borderRadius: activeFilter === "Open" ? "10px" : "0",
            transition: "0.3s all",
          }}
        >
          <Typography variant="h3">{openC}</Typography>
          <Typography variant="h6">Open Tickets</Typography>
        </BoxStyled>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <BoxStyled
          onClick={() => {
            setActiveFilter("Closed");
            dispatch(setVisibilityFilter("Closed"));
          }}
          sx={{
            backgroundColor: activeFilter === "Closed" ? theme.palette.error.main : theme.palette.error.light,
            color: activeFilter === "Closed" ? " #fff" : theme.palette.error.main,
            borderRadius: activeFilter === "Closed" ? "10px" : "0",
            transition: "0.3s all",
          }}
        >
          <Typography variant="h3">{closeC}</Typography>
          <Typography variant="h6">Closed Tickets</Typography>
        </BoxStyled>
      </Grid>
    </Grid>
  );
}

export default TicketFilter;
